// DataTable.jsx
import React, { useState } from "react";
import "./Codebook.css"; // koristiš iste stilove
import DynamicModal from "../../components/Modal/DynamicModal";
import { handleUpdateGeometry } from "../update/UpdateGeometry";

function DataTable({ data, orientation = "horizontal", selectedFeature }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newGeometry, setNewGeometry] = useState({ x: "", y: "", layerCRS: "" });
    const [isUpdated, setIsUpdated] = useState(false);
    const feature = selectedFeature?.[0];

    if (!data || data.length === 0) return null;

    const handleInputChange = (key, value) => {
        setNewGeometry((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleGeometrySubmit = async () => {
        if (!feature || !feature.id || !feature.geometry_name) return;

        const inputCoords = [parseFloat(newGeometry.x), parseFloat(newGeometry.y)];

        await handleUpdateGeometry(
            feature,
            inputCoords,
            newGeometry.layerCRS,
            "elektro:mjerna_mjesta",
            feature.geometry_name,
            setIsUpdated
        );

        setIsModalOpen(false);
        setNewGeometry({ x: "", y: "", layerCRS: "" });
        setTimeout(() => {
            setIsUpdated(false);
        }, 3000);
    };

    const mainContent = (
        <div className="updateMM-container">
            <form className="updateMM-form">
                <div className="form-group">
                    <label>X koordinata:</label>
                    <input
                        type="number"
                        value={newGeometry.x}
                        onChange={(e) => handleInputChange("x", e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Y koordinata:</label>
                    <input
                        type="number"
                        value={newGeometry.y}
                        onChange={(e) => handleInputChange("y", e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Unesite CRS sloja (npr. EPSG:3857):</label>
                    <input
                        type="text"
                        value={newGeometry.layerCRS}
                        onChange={(e) => handleInputChange("layerCRS", e.target.value)}
                    />
                </div>
            </form>
        </div>
    );

    const footerContent = (
        <>
            <button type="button" className="app-btn app-btn-success" onClick={handleGeometrySubmit}>
                Sačuvaj
            </button>
            <button
                type="button"
                className="app-btn app-btn-secondary"
                onClick={() => {
                    setIsModalOpen(false);
                    setNewGeometry({ x: "", y: "", layerCRS: "" }); // reset
                }}
            >
                Otkaži
            </button>

        </>
    );

    const shouldShowGeometryFix =
        orientation === "vertical" &&
        feature?.geometry?.coordinates?.[0] === 1 &&
        feature?.geometry?.coordinates?.[1] === 1;

    if (orientation === "vertical") {
        const row = data[0];
        return (
            <div className="codebok-div-table-vertical">
                <table className="codebook-table-vertical">
                    <tbody>
                        {Object.entries(row).map(([key, value]) => (
                            <tr key={key}>
                                <th>{key}</th>
                                <td>{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {shouldShowGeometryFix && (
                    <>
                        <button className="openUpdateGModalButton" onClick={() => setIsModalOpen(true)}>
                            Ažuriraj geometriju
                        </button>
                        {isUpdated && (
                            <div className="success-message">Geometrija uspješno ažurirana!</div>
                        )}
                        <DynamicModal
                            isOpen={isModalOpen}
                            onRequestClose={() => setIsModalOpen(false)}
                            title="Ažuriranje geometrije"
                            mainContent={mainContent}
                            footerContent={footerContent}
                            customWidth="500px"
                            customHeight="450px"
                        />
                    </>
                )}
            </div>
        );
    }

    return (
        <table className="codebook-table-horizontal">
            <thead>
                <tr>
                    {Object.keys(data[0]).map((key) => (
                        <th key={key}>{key}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((row, i) => (
                    <tr key={i}>
                        {Object.values(row).map((value, j) => (
                            <td key={j}>{value}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default DataTable;
